(() => {
  const SELECTORS = {
    section: '[data-farmers-process-section]',
    viewport: '[data-farmers-process-viewport]',
    card: '.farmers-process__card',
    button: '[data-farmers-process-scroll]'
  };

  const initializedSections = new WeakSet();

  const initFarmersProcessSection = (section) => {
    if (!section || initializedSections.has(section)) return;
    initializedSections.add(section);

    const viewport = section.querySelector(SELECTORS.viewport);
    const buttons = Array.from(section.querySelectorAll(SELECTORS.button));
    if (!viewport || !buttons.length) return;

    const updateButtons = () => {
      const maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const canScroll = maxScrollLeft > 1;

      buttons.forEach((button) => {
        const isPrevious = button.dataset.farmersProcessScroll === 'prev';
        const isDisabled = !canScroll || (isPrevious ? viewport.scrollLeft <= 1 : viewport.scrollLeft >= maxScrollLeft - 1);

        button.classList.toggle('is-disabled', isDisabled);
        button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.getAttribute('aria-disabled') === 'true') return;

        const direction = button.dataset.farmersProcessScroll === 'prev' ? -1 : 1;
        const firstCard = viewport.querySelector(SELECTORS.card);
        const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : viewport.clientWidth / 2;
        const styles = window.getComputedStyle(viewport.querySelector('[data-farmers-process-track]') || viewport);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        const scrollAmount = Math.max(cardWidth + gap, viewport.clientWidth * 0.85);

        viewport.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
      });
    });

    viewport.addEventListener('scroll', () => window.requestAnimationFrame(updateButtons), { passive: true });
    window.addEventListener('resize', () => window.requestAnimationFrame(updateButtons));
    window.addEventListener('load', updateButtons, { once: true });
    updateButtons();
  };

  const initAll = (root = document) => {
    root.querySelectorAll(SELECTORS.section).forEach(initFarmersProcessSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
